module.exports = __webpack_public_path__ + "static/media/frykteleg.eb5f5b92.m4a";